import React, { Component } from 'react'
import { Card, CardLink, CardBody, Form, Input, FormFeedback, FormGroup, Button, Label, CustomInput } from 'reactstrap'
import Fetch from '../../Auxiliares/fetch'
import { toast } from 'react-toastify'
import validaciones from '../../Auxiliares/validaciones'

export default class modModulo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: this.props.id,
            doc: this.props.doc,
            ppp: this.props.ppp,
            doble_cara: this.props.doble_cara,
            switch: this.props.doble_cara ? 'Doble cara' : 'Una cara',
            errors: {}
        }
        this.guardar = this.guardar.bind(this)
    }

    setValue(field, ev) {
        this.setState({ [field]: ev.target.value }, ()=> {
            let value;
            switch([field].toString()){
                case 'doc':
                    if (validaciones.validar_titulo(this.state.doc)) {
                        value = validaciones.validar_titulo(this.state.doc)
                        this.setState(prevState => ({ errors: { ...prevState.errors, doc: value } }));
                    } else {
                        this.setState({ errors: (delete Array.from(this.state.errors).doc) });
                    }
                break;

                case 'ppp':
                    if (validaciones.validar_resolucion(this.state.ppp)) {
                        value = validaciones.validar_resolucion(this.state.ppp)
                        this.setState(prevState => ({ errors: { ...prevState.errors, ppp: value } }));
                    } else {
                        this.setState({ errors: (delete Array.from(this.state.errors).ppp) });
                    }
                break;

                default:
                    break;
            }
        })
    }

    setSwitchValue(e) {
        let tipo;
        if(!this.state.doble_cara){
            tipo = "Doble cara";
        }else{
            tipo = "Una cara";
        }

        this.setState(prevState =>({
            doble_cara: !prevState.doble_cara,
            switch: tipo
        }));
    }

    guardar() {
        const { id, doc, ppp, doble_cara } = this.state

        if (validaciones.sinErrores(this.state.errors)) {
            Fetch('/api/updateDoc', {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id, doc, ppp, doble_cara })
            }).then(Response => {
                this.props.actualizar();
                this.props.cerrar(); 
            }).catch(err => {
                switch (err.status) {

                    case 600:
                        toast.error('Error inesperado')
                        break;

                    case 601:
                        toast.error('Este documento ya existe')
                        break;

                    case 604:
                        toast.error('Este usuario no pudo ser registrado')
                        break;

                    default:
                        break;
                }
            })
        }
    }

    render() {

        return (
            <Card className="border-0">
                <CardBody>
                    <Form method="post" encType="multipart/form-data">

                        <FormGroup>
                            <Input type="text" name="doc" id="doc" placeholder="Nombre doc" onChange={this.setValue.bind(this, 'doc')} className="mb-3 py-4 d-flex w-100 font-weight-bold" defaultValue={this.state.doc} invalid={this.state.errors.doc} />
                            <FormFeedback>{this.state.errors.doc}</FormFeedback>
                        </FormGroup>

                        <FormGroup>
                            <Label for="ppp">Resolucion del documento</Label>
                            <Input type="select" name="ppp" id="ppp"  onChange={this.setValue.bind(this, 'ppp')} defaultValue={this.state.ppp}>
                                <option>200</option>
                                <option>300</option>
                                <option>400</option>
                                <option>600</option>
                                <option>1200</option>
                            </Input>
                        </FormGroup>

                        <FormGroup>
                            <Label for="doble_cara">Tipo de documento</Label>
                            <div>
                                <CustomInput type="switch" id="doble_cara" name="doble_cara" label={this.state.switch} onChange={this.setSwitchValue.bind(this)} checked={this.state.doble_cara}/>
                            </div>
                        </FormGroup>

                        <div className="text-center">
                        <CardLink>
                            <Button color="info" onClick={this.guardar}>Guardar</Button>
                            <Button color="white" onClick={this.props.cerrar} >Cancelar</Button>
                        </CardLink>
                        </div>
                    </Form>
                </CardBody>
            </Card >
        )
    }
}
